import http from "./http";
import {useRequest} from "ahooks";

let apiPath = {
  qryShopItemCommentPageForApp: '/item/shopItemComment/qryShopItemCommentPageForApp',
  batchAddComment: '/item/shopItemComment/batchAddComment',
  
};

export const useQryShopItemCommentPageForApp = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    
    return http({
      url: apiPath.qryShopItemCommentPageForApp,
      method: 'get',
      data: q
    }, { noAlias: true ,});
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    getCommentHandle: runAsync
  };
};

export const useBatchAddComment = ()=>{
  const { data, runAsync, error, loading } = useRequest((q) => {
    
    return http({
      url: apiPath.batchAddComment,
      method: 'post',
      data: q
    }, { noAlias: true,json:true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    addCommentHandle: runAsync
  };
}

